import * as Yup from 'yup';

export const AmountSchema = Yup.object().shape({
  amount: Yup.number()
    .required('Please enter amount')
    .moreThan(0, 'Amount must be greater than $0')
    .lessThan(1000000, 'Amount must be less than $1,000,000'),
});
